import type React from 'react';
import { InputV2 } from '@withjoy/joykit';

type InputV2Props = React.ComponentProps<typeof InputV2>;

/**
 * InputV2 already spreads unrecognized props onto the underlying <input>, so the
 * native `list` attribute works at runtime — it just isn't declared on the
 * public prop type. Typed alias scoped to the name-affix fields so the datalist
 * wiring doesn't require widening the joykit component's API.
 */
export const InputWithDatalist = InputV2 as React.ComponentType<InputV2Props & { list?: string }>;
